// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import { styled } from '@mui/material/styles';
import type { SxProps } from '@mui/material/styles';
import { enqueueSnackbar } from 'notistack';
import * as React from 'react';
import { useAppContext } from '../../../context/AppContext';
import { Typography } from '../../../lib/base';
import type { Theme } from '../../../theme/Theme';
import { clipboard } from '../../../utils';

interface Props {
  readonly name: string;
  readonly value: string;
  readonly sx?: SxProps<Theme>;
}

const StyledLink = styled(Typography)(({ theme }) => ({
  cursor: 'pointer',
  color: theme.palette.secondary.main,
  '&:hover': {
    color: theme.palette.secondary.dark,
    textDecoration: 'underline',
  },
}));

export default function CopyText({ value, name, sx }: Props) {
  const { userAgent } = useAppContext();
  const onClickCopy = () => {
    clipboard
      .copy(value, userAgent)
      .then(() => {
        enqueueSnackbar(`Copied ${name} to clipboard`, { variant: 'success' });
      })
      .catch(() => {
        enqueueSnackbar(`Error copying ${name} to clipboard`, { variant: 'error', autoHideDuration: 10000 });
      });
  };

  return (
    <StyledLink sx={[...(Array.isArray(sx) ? sx : [sx])]} onClick={onClickCopy}>
      {value}
    </StyledLink>
  );
}
